var map = {
	"./choose_1_3.png": "ADOV",
	"./choose_2_3.png": "6Hoi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dWR";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/choose_.*_3\.png$
// module id = 6dWR
// module chunks = 0